import { useEffect, useState } from "react";
import styled from "../styled-components";

export type RImage = {
  src: string;
  alt: string;
}

type RotatingImageProps = {
  images: RImage[]
}

const RotatingImage = ({ images }: RotatingImageProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 10000); // 10 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  const { src, alt } = images[currentIndex];

  return <Person src={src} alt={alt} loading="lazy" />;
}

const Person = styled.img`
  width: min(320px, 100%);
  height: auto;
  display: block;
  object-fit: contain;
  filter: drop-shadow(0 10px 24px rgba(0, 0, 0, 0.06));
`;

export default RotatingImage